export default __webpack_public_path__ + "static/media/arrow-blue.ba95d6b8.svg";